import { createStore, combineReducers, applyMiddleware, Store } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { usersReducer } from "./users/reducers";
import { rolesReducer } from "./roles/reducers";

export const rootReducer = combineReducers({
  users: usersReducer,
  roles: rolesReducer
});

export type AppState = ReturnType<typeof rootReducer>;
export let currentStore: Store;

export default function configureStore() {
  const middlewares = [thunkMiddleware];
  const middleWareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(
    rootReducer,
    composeWithDevTools(middleWareEnhancer)
  );

  currentStore = store;
  return store;
}
